module.exports = __webpack_public_path__ + "img/p2.6bb7ac2f.png";